export enum EndpointTypeEnum {
  DATABASE = 'Database',
  SFTP = 'SFTP',
  API = 'API',
  LOCALFILE = 'LocalFile',
  EMAIL = 'EMAIL',
  S3 = 'S3'
}
